<template>
  <div class="mt-3 w-100">
    <span>{{ $t('yourEbtBalance', { maskedCardNum: maskedCardNum }) }}</span>

    <div class="my-3">
      <h1 v-if="snapBalance" class="text-primary text-center">
        {{ $t('ebtSnap') }}: {{ $filters.currency(snapBalance) }}
      </h1>
      <h1 v-if="cashBalance" class="text-primary text-center">
        {{ $t('ebtCash') }}: {{ $filters.currency(cashBalance) }}
      </h1>
    </div>

    <button
      @click="viewEbtItems"
      v-if="showViewEbtItems"
      class="btn btn-primary w-100 mt-3"
      data-testid="shopEbtItemsButton"
    >
      {{ $t('shopEbtItems') }}
    </button>

    <button v-if="token" @click="done" class="btn btn-primary w-100 mt-3" data-testid="doneButton">
      {{ $t('done') }}
    </button>
    <button
      v-else
      @click="addToWallet"
      class="btn btn-outline-primary w-100 mt-3"
      data-testid="addToWalletButton"
    >
      {{ $t('addToWallet') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'EbtBalanceDisplay',
  emits: ['addToWallet', 'done', 'viewEbtItems'],
  props: {
    token: {
      type: Object,
    },
    snapBalance: {
      type: Number,
      required: true,
    },
    cashBalance: {
      type: Number,
      required: true,
    },
    maskedCardNum: {
      type: String,
      required: true,
    },
    paymentMethod: {
      type: Object,
      required: true,
    },
    showViewEbtItems: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    async addToWallet() {
      this.$emit('addToWallet');
    },
    done() {
      this.$emit('done');
    },
    viewEbtItems() {
      this.$emit('viewEbtItems');
    },
  },
};
</script>
